import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content } from 'rsuite';
import { get, isEmpty, includes } from 'lodash/fp';
import { useParams } from 'react-router-dom';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { parseInt } from '../../../../helpers/utils';
import { viewAccess } from '../../../../helpers/permission';
import {
  fetchPosTrackingMethods,
  fetchPosLocationsForTrackingMethod,
  createPosLocationsForTrackingMethod,
  deletePosLocationsForTrackingMethod
} from '../../../../redux/Settings/sagas/routines';
import { fetchPosLocationOptions } from '../../../../redux/POS/sagas/options/routines';
import { getSortedPosLocationOptions } from '../../../../redux/POS/selectors/options';
import {
  getIsSaving,
  getIsDeleting,
  getPosLocationsForTrackingMethod
} from '../../../../redux/Settings/selectors/pos/trackingMethodLocations';
import { getTrackingMethodForId } from '../../../../redux/Settings/selectors/pos/trackingMethods';
import {
  settingsPosPath,
  settingsPosTrackingMethodLocationsPath
} from '../../../Paths';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/settings/pos/PageLayout';
import Breadcrumb from '../../../../components/Breadcrumb';
import TrackingMethodLocationForm from '../../../../components/settings/pos/TrackingMethodLocationForm';

export default () => {
  const dispatch = useDispatch();
  const id = parseInt(get('id', useParams()));
  const isSaving = useSelector(getIsSaving);
  const isDeleting = useSelector(getIsDeleting);
  const locationOptions = useSelector(getSortedPosLocationOptions);
  const trackingMethod = useSelector(state =>
    getTrackingMethodForId(state, id)
  );
  const trackingMethodLocations = useSelector(state =>
    getPosLocationsForTrackingMethod(state, id)
  );
  const headerTitle = `Edit "${get('label', trackingMethod)}" Locations`;

  useEffect(
    () => {
      if (isEmpty(locationOptions)) dispatch(fetchPosLocationOptions());
    },
    [locationOptions]
  );

  useEffect(
    () => {
      if (!trackingMethod) dispatch(fetchPosTrackingMethods());
    },
    [trackingMethod]
  );

  useEffect(
    () => {
      if (isEmpty(trackingMethodLocations))
        dispatch(fetchPosLocationsForTrackingMethod(id));
    },
    [trackingMethodLocations]
  );

  const handleSubmit = (
    { locationId, defaultLocationId },
    deleteLocationIds
  ) => {
    if (!isEmpty(deleteLocationIds)) {
      const deleteBody = { locationId: deleteLocationIds };
      dispatch(deletePosLocationsForTrackingMethod({ id, body: deleteBody }));
    }

    if (!isEmpty(locationId)) {
      const isValidDefaultId = includes(defaultLocationId, locationId);
      const body = {
        locationId,
        defaultLocationId: isValidDefaultId ? defaultLocationId : null
      };
      dispatch(createPosLocationsForTrackingMethod({ id, body }));
    }
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.POS)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            {
              path: settingsPosPath,
              label: 'POS Settings'
            },
            {
              path: settingsPosTrackingMethodLocationsPath,
              label: 'Tracking Method Locations'
            },
            { label: headerTitle }
          ]}
        />
        <PageHeader title={headerTitle} />
        <Content>
          <TrackingMethodLocationForm
            onSubmit={handleSubmit}
            isSaving={isSaving || isDeleting}
            locationOptions={locationOptions}
            trackingMethodLocations={trackingMethodLocations}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
